<template>
  <div class="resume-form-container" :class="{ 'no-card-style': noCardStyle }" v-if="visible || resumeData.name || isParsed">
    <div class="resume-form-card" :class="{ 'no-card': noCardStyle }">
      <div class="resume-form-header">
        <h2 class="resume-form-title">
          {{ title }}
        </h2>
        <div class="resume-form-header-actions">
          <!-- 编辑、保存、取消按钮（当 showEditButtons 为 true 时显示） -->
          <div v-if="showEditButtons" class="resume-edit-actions">
            <el-button 
              v-if="isEditing" 
              type="default" 
              class="resume-cancel-btn" 
              @click="handleCancel"
            >
              <i class="el-icon-close"></i>
              取消
            </el-button>
            <el-button 
              type="primary" 
              class="resume-edit-btn" 
              @click="handleToggleEdit"
            >
              <i :class="isEditing ? 'el-icon-check' : 'el-icon-edit'"></i>
              {{ isEditing ? '保存' : '编辑' }}
            </el-button>
          </div>
          <!-- 勾选：是否将当前简历信息同步更新到个人信息（只有已解析时才显示） -->
          <el-checkbox
            v-if="isParsed && !showEditButtons"
            v-model="syncToPersonalInfo"
            class="resume-sync-checkbox"
          >
            更新到个人信息
          </el-checkbox>
        </div>
      </div>

      <div class="resume-form-content">
        <!-- 1. Basic Information -->
        <section class="resume-section">
          <h3 class="resume-section-title">
            基本信息
          </h3>
          <el-form :model="resumeData" label-width="80px" label-position="top" :disabled="!isEditing">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="姓名">
                  <el-input 
                    v-model="resumeData.real_name" 
                  @blur="emitUpdate"
                  placeholder="请输入姓名" 
                    prefix-icon="el-icon-user"
                />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="手机号">
                  <el-input 
                    v-model="resumeData.mobile" 
                  @blur="emitUpdate"
                  placeholder="请输入手机号" 
                    prefix-icon="el-icon-phone"
                />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="邮箱">
                  <el-input 
                  v-model="resumeData.email" 
                  @blur="emitUpdate"
                  placeholder="请输入邮箱" 
                    prefix-icon="el-icon-message"
                />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="出生日期">
                  <el-date-picker
                    v-model="resumeData.birthday" 
                    @change="emitUpdate"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="showExpectationFields" :xs="24" :sm="12" :md="8">
                <el-form-item label="期望城市">
                  <el-input 
                    v-model="resumeData.desired_city" 
                    @blur="emitUpdate"
                    placeholder="请输入期望城市"
                    prefix-icon="el-icon-location"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="showExpectationFields" :xs="24" :sm="12" :md="8">
                <el-form-item label="期望薪资">
                  <el-input 
                    v-model="resumeData.expected_salary" 
                    @blur="emitUpdate"
                    placeholder="请输入期望薪资"
                    prefix-icon="el-icon-money"
                />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </section>

        <!-- 2. Education -->
        <section class="resume-section">
          <div class="resume-section-header">
            <h3 class="resume-section-title">
              <i class="el-icon-school"></i>
              教育经历
            </h3>
          </div>
          <div class="resume-list">
            <div 
              v-for="(edu, index) in resumeData.education_list" 
              :key="index" 
              class="resume-item"
            >
              <div class="resume-item-header">
                <span class="resume-item-index">教育经历 {{ index + 1 }}</span>
              <div 
                v-if="isEditing"
                class="resume-item-delete" 
                @click="removeEducation(index)"
              >
                <i class="el-icon-delete"></i>
                  <span>删除</span>
              </div>
              </div>
              <el-form :model="edu" label-width="80px" label-position="top" :disabled="!isEditing">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="学校名称">
                      <el-input 
                    v-model="edu.school" 
                    @blur="emitUpdate"
                    placeholder="学校名称" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="专业">
                      <el-input 
                    v-model="edu.major" 
                    @blur="emitUpdate"
                    placeholder="专业名称" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="学历">
                      <el-input 
                    v-model="edu.degree" 
                    @blur="emitUpdate"
                    placeholder="例如：本科" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="GPA">
                      <el-input 
                        v-model="edu.gpa" 
                      @blur="emitUpdate"
                        placeholder="请输入GPA"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="时间段">
                      <el-date-picker
                        :value="formatDateRangeForPicker(edu.start_year, edu.end_year)"
                        @input="handleDateRangeChange($event, edu, 'start_year', 'end_year')"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                    />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <button 
              v-if="isEditing"
              @click="addEducation" 
              class="add-item-btn"
            >
              <i class="el-icon-plus"></i>
              添加教育经历
            </button>
          </div>
        </section>

        <!-- 3. Work Experience -->
        <section class="resume-section">
          <div class="resume-section-header">
            <h3 class="resume-section-title">
              <i class="el-icon-suitcase"></i>
              工作经历
            </h3>
          </div>
          <div class="resume-list">
            <div 
              v-for="(exp, index) in resumeData.work_experience_list" 
              :key="index" 
              class="resume-item"
            >
              <div class="resume-item-header">
                <span class="resume-item-index">工作经历 {{ index + 1 }}</span>
              <div 
                v-if="isEditing"
                class="resume-item-delete" 
                  @click="removeExperience('work_experience_list', index)"
              >
                <i class="el-icon-delete"></i>
                  <span>删除</span>
              </div>
              </div>
              <el-form :model="exp" label-width="80px" label-position="top" :disabled="!isEditing">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="公司名称">
                      <el-input 
                    v-model="exp.company" 
                    @blur="emitUpdate"
                    placeholder="公司名称" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="职位">
                      <el-input 
                    v-model="exp.role" 
                    @blur="emitUpdate"
                    placeholder="职位名称" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="城市">
                      <el-input 
                        v-model="exp.city" 
                      @blur="emitUpdate"
                    />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="国家">
                      <el-input 
                        v-model="exp.country" 
                      @blur="emitUpdate"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="时间段">
                      <el-date-picker
                        :value="formatDateRangeForPicker(exp.start_year, exp.end_year)"
                        @input="handleDateRangeChange($event, exp, 'start_year', 'end_year')"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                <el-col :xs="24" :sm="24">
                  <el-form-item label="工作描述">
                      <el-input 
                    v-model="exp.description" 
                    @blur="emitUpdate"
                        type="textarea"
                        :rows="3"
                    placeholder="描述你的工作内容..."
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <button 
              v-if="isEditing"
              @click="addExperience('work_experience_list')" 
              class="add-item-btn"
            >
              <i class="el-icon-plus"></i>
              添加工作经历
            </button>
          </div>
        </section>

        <!-- 4. Project Experience -->
        <section class="resume-section">
          <div class="resume-section-header">
            <h3 class="resume-section-title">
              <i class="el-icon-suitcase"></i>
              项目经历
            </h3>
          </div>
          <div class="resume-list">
            <div 
              v-for="(project, index) in resumeData.project_list" 
              :key="index" 
              class="resume-item"
            >
              <div class="resume-item-header">
                <span class="resume-item-index">项目经历 {{ index + 1 }}</span>
                <div 
                  v-if="isEditing"
                  class="resume-item-delete" 
                  @click="removeProject(index)"
                >
                <i class="el-icon-delete"></i>
                  <span>删除</span>
              </div>
                </div>
              <el-form :model="project" label-width="80px" label-position="top" :disabled="!isEditing">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="项目名称">
                      <el-input 
                        v-model="project.project_name" 
                    @blur="emitUpdate"
                        placeholder="项目名称"
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="时间段">
                      <el-date-picker
                        :value="formatDateRangeForPicker(project.start_year, project.end_year)"
                        @input="handleDateRangeChange($event, project, 'start_year', 'end_year')"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="项目描述">
                      <el-input 
                        v-model="project.description" 
                      @blur="emitUpdate"
                        type="textarea"
                        :rows="4"
                        placeholder="描述项目内容..."
                    />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <button 
              v-if="isEditing"
              @click="addProject" 
              class="add-item-btn"
            >
              <i class="el-icon-plus"></i>
              添加项目经历
            </button>
          </div>
        </section>

        <!-- 5. Awards & Competitions -->
        <section class="resume-section">
          <div class="resume-section-header">
            <h3 class="resume-section-title">
              <i class="el-icon-medal"></i>
              奖项荣誉
            </h3>
          </div>
          <div class="resume-list">
            <div 
              v-for="(award, index) in resumeData.award_list" 
              :key="index" 
              class="resume-item"
            >
              <div class="resume-item-header">
                <span class="resume-item-index">奖项荣誉 {{ index + 1 }}</span>
              <div 
                v-if="isEditing"
                class="resume-item-delete" 
                @click="removeAward(index)"
              >
                <i class="el-icon-delete"></i>
                  <span>删除</span>
              </div>
              </div>
              <el-form :model="award" label-width="80px" label-position="top" :disabled="!isEditing"> 
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="奖项名称">
                      <el-input 
                        v-model="award.title" 
                    @blur="emitUpdate"
                    placeholder="奖项名称" 
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="获奖时间">
                      <el-date-picker
                    v-model="award.date" 
                        @change="emitUpdate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                  />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24">
                    <el-form-item label="描述">
                      <el-input 
                    v-model="award.description" 
                    @blur="emitUpdate"
                        type="textarea"
                        :rows="2"
                    placeholder="奖项描述..."
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <button 
              v-if="isEditing"
              @click="addAward" 
              class="add-item-btn"
            >
              <i class="el-icon-plus"></i>
              添加奖项荣誉
            </button>
          </div>
        </section>

        <!-- 6. Self Evaluation -->
        <section class="resume-section">
          <div class="resume-section-header">
            <h3 class="resume-section-title">
              <i class="el-icon-edit"></i>
              个人简介
            </h3>
          </div>
          <el-input 
            v-model="resumeData.personal_profile" 
            @blur="emitUpdate"
            type="textarea"
            :rows="5"
            placeholder="请输入个人简介..."
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { setInfo } from '@/api/user'

const INITIAL_RESUME_DATA = {
      real_name: '',
      email: '',
      mobile: '',
      birthday: '',
  desired_city: '',
  expected_salary: '',
  education_list: [],
  work_experience_list: [],
  project_list: [],
  award_list: [],
  personal_profile: ''
}

export default {
  name: 'ResumeInfo',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isParsed: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({ ...INITIAL_RESUME_DATA })
    },
    editable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '个人简历信息'
    },
    showEditButtons: {
      type: Boolean,
      default: false
    },
    noCardStyle: {
      type: Boolean,
      default: false
    },
    showExpectationFields: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      resumeData: { ...INITIAL_RESUME_DATA },
      updateTimer: null,
      // 如果显示编辑按钮，默认非编辑状态（只读）；否则根据 editable prop
      isEditing: this.showEditButtons ? false : (this.editable !== undefined ? this.editable : true),
      originalData: null,
      // 是否将当前简历信息同步更新到个人信息
      syncToPersonalInfo: false,
      // 备份原始数据（用于取消编辑）
      originalResumeData: null
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          const newData = { ...INITIAL_RESUME_DATA, ...newVal, real_name: newVal.full_name 
            || newVal.real_name , mobile: newVal.phone || newVal.mobile, birthday: newVal.birthday || newVal.date_of_birth }
          // 确保数组字段存在
          if (!Array.isArray(newData.education_list)) newData.education_list = []
          if (!Array.isArray(newData.work_experience_list)) newData.work_experience_list = []
          if (!Array.isArray(newData.project_list)) newData.project_list = []
          if (!Array.isArray(newData.award_list)) newData.award_list = []
          
          // 只在数据真正变化时更新，避免循环
          const currentStr = JSON.stringify(this.resumeData)
          const newStr = JSON.stringify(newData)
          if (currentStr !== newStr) {
            this.resumeData = newData
          }
        }
      },
      immediate: true,
      deep: true
    },
    editable: {
      handler(newVal) {
        // 只有在不显示编辑按钮时才根据 editable prop 更新
        if (!this.showEditButtons) {
          this.isEditing = newVal !== undefined ? newVal : true
        }
      },
      immediate: true
    },
    showEditButtons: {
      handler(newVal) {
        // 如果显示编辑按钮，强制设置为非编辑状态（只读模式）
        if (newVal) {
          this.isEditing = false
        } else {
          // 否则根据 editable prop 设置
          this.isEditing = this.editable !== undefined ? this.editable : true
        }
      },
      immediate: true
    }
  },
  methods: {
    emitUpdate() {
      // 直接触发更新，不延迟
      this.$emit('input', JSON.parse(JSON.stringify(this.resumeData)))
      this.$emit('change', JSON.parse(JSON.stringify(this.resumeData)))
    },
    // 格式化日期范围供日期选择器显示
    // 如果值是年份格式（4位数字），转换为完整日期格式（yyyy-01-01）
    formatDateRangeForPicker(startValue, endValue) {
      if (!startValue || !endValue) return null
      
      // 如果已经是完整日期格式（包含 "-"），直接使用
      let startDate = startValue
      let endDate = endValue
      
      // 如果是年份格式（只有4位数字），转换为完整日期
      if (/^\d{4}$/.test(startValue)) {
        startDate = `${startValue}-01-01`
      }
      if (/^\d{4}$/.test(endValue)) {
        endDate = `${endValue}-12-31`
      }
      
      return [startDate, endDate]
    },
    handleDateRangeChange(value, item, startField, endField) {
      if (value && Array.isArray(value) && value.length === 2) {
        // 保存完整日期格式（yyyy-MM-dd），这样日期选择器可以正常显示
        // 如果API需要年份格式，可以在提交时提取年份部分
        item[startField] = value[0] || ''
        item[endField] = value[1] || ''
      } else {
        item[startField] = ''
        item[endField] = ''
      }
      this.emitUpdate()
    },
    addEducation() {
      if (!this.resumeData.education_list) {
        this.$set(this.resumeData, 'education_list', [])
      }
      this.resumeData.education_list.push({
        school: '',
        major: '',
        degree: '',
        gpa: '',
        start_year: '',
        end_year: ''
      })
      this.emitUpdate()
    },
    removeEducation(index) {
      this.resumeData.education_list.splice(index, 1)
      this.emitUpdate()
    },
    addExperience(type) {
      if (!this.resumeData[type]) {
        this.$set(this.resumeData, type, [])
      }
      if (type === 'work_experience_list') {
      this.resumeData[type].push({
        company: '',
        role: '',
          city: '',
          country: '',
          start_year: '',
          end_year: '',
        description: ''
      })
      }
      this.emitUpdate()
    },
    removeExperience(type, index) {
      this.resumeData[type].splice(index, 1)
      this.emitUpdate()
    },
    addProject() {
      if (!this.resumeData.project_list) {
        this.$set(this.resumeData, 'project_list', [])
      }
      this.resumeData.project_list.push({
        project_name: '',
        start_year: '',
        end_year: '',
        description: ''
      })
      this.emitUpdate()
    },
    removeProject(index) {
      this.resumeData.project_list.splice(index, 1)
      this.emitUpdate()
    },
    addAward() {
      if (!this.resumeData.award_list) {
        this.$set(this.resumeData, 'award_list', [])
      }
      this.resumeData.award_list.push({
        title: '',
        date: '',
        description: ''
      })
      this.emitUpdate()
    },
    removeAward(index) {
      this.resumeData.award_list.splice(index, 1)
      this.emitUpdate()
    },
    async updatePersonalInfoIfNeeded() {
      if (this.syncToPersonalInfo) {
        try {
          // 构建完整的 payload，包含所有表单字段
          const payload = {
            ...this.resumeData,
            // 将数组字段转换为 JSON 字符串
            education_list: JSON.stringify(this.resumeData.education_list || []),
            work_experience_list: JSON.stringify(this.resumeData.work_experience_list || []),
            project_list: JSON.stringify(this.resumeData.project_list || []),
            award_list: JSON.stringify(this.resumeData.award_list || [])
          }
          const res = await setInfo(payload)
          if (res && res.data && res.data.code === 1) {
            this.$message.success('已将简历信息同步更新到个人信息')
            return true
          } else {
            console.warn('同步个人信息失败:', res?.data?.msg || '未知错误')
            return false
          }
        } catch (e) {
          console.warn('同步个人信息失败:', e)
          return false
        }
      }
      return true // 未勾选，不需要更新，返回 true 表示可以继续
    },
    // 切换编辑模式（当 showEditButtons 为 true 时使用）
    async handleToggleEdit() {
      if (this.isEditing) {
        // 保存模式
        await this.handleSave()
      } else {
        // 进入编辑模式
        this.originalResumeData = JSON.parse(JSON.stringify(this.resumeData))
      this.isEditing = true
      }
    },
    // 取消编辑
    handleCancel() {
      if (this.originalResumeData) {
        this.resumeData = JSON.parse(JSON.stringify(this.originalResumeData))
      this.emitUpdate()
      }
      this.isEditing = false
      this.originalResumeData = null
    },
    // 保存数据（当 showEditButtons 为 true 时使用）
    async handleSave() {
      try {
        // 构建完整的 payload，包含所有表单字段
        const submitData = {
          ...this.resumeData,
          // 将数组字段转换为 JSON 字符串
          education_list: JSON.stringify(this.resumeData.education_list || []),
          work_experience_list: JSON.stringify(this.resumeData.work_experience_list || []),
          project_list: JSON.stringify(this.resumeData.project_list || []),
          award_list: JSON.stringify(this.resumeData.award_list || [])
        }
        
        // 调用 API 保存
        const res = await setInfo(submitData)
        if (res && res.data && res.data.code === 1) {
          // 埋点：简历创建/完善
          const userInfo = localStorage.getItem('userInfo')
          const userId = userInfo ? JSON.parse(userInfo).id : ''
          if (this.$tracking && userId) {
            // 计算完善字段数（对比原始数据）
            const originalFields = this.originalResumeData || {}
            const newFields = this.resumeData || {}
            let improveFieldCnt = 0
            
            // 检查主要字段是否有变化或新增
            const fieldsToCheck = ['real_name', 'mobile', 'email', 'birthday', 'personal_profile', 
              'education_list', 'work_experience_list', 'project_list', 'award_list']
            fieldsToCheck.forEach(field => {
              const originalValue = originalFields[field]
              const newValue = newFields[field]
              if (newValue && (!originalValue || JSON.stringify(originalValue) !== JSON.stringify(newValue))) {
                improveFieldCnt++
              }
            })
            
            // 计算完成率（简化计算：已填写字段数 / 总字段数）
            const totalFields = 10 // 假设总共有10个主要字段
            const filledFields = fieldsToCheck.filter(field => {
              const value = newFields[field]
              if (Array.isArray(value)) return value.length > 0
              return value && value !== ''
            }).length
            const completionRate = filledFields / totalFields
            
            this.$tracking.trackResumeCreateOrImprove(userId, {
              improveFieldCnt: improveFieldCnt,
              aiResumeOptimizeUsed: 0, // 如果有AI优化功能，需要传入实际值
              completionRate: completionRate
            })
          }
          
          this.$message.success('保存成功')
      this.isEditing = false
          // 更新原始数据
          this.originalResumeData = JSON.parse(JSON.stringify(this.resumeData))
          // 触发保存成功事件
          this.$emit('save-success', this.resumeData)
        } else {
          this.$message.error(res?.data?.msg || '保存失败，请稍后重试')
        }
      } catch (error) {
        console.error('保存个人信息失败:', error)
        this.$message.error('网络错误，请检查网络连接后重试')
      }
    }
  },
  beforeDestroy() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer)
    }
  }
}
</script>

<style scoped lang="scss">
.resume-form-container {
  animation: slideUp 0.5s ease-out forwards;
  
  &.no-card-style {
    animation: none;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.resume-form-card {
  background: white;
  border-radius: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  
  &.no-card {
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border: none;
    overflow: visible;
  }
}

.resume-form-header {
  padding: 24px 32px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, rgba(239, 246, 255, 0.3), white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .no-card & {
    padding: 0 20px;
    border-bottom: 0;
    background: transparent;
  }
}

.resume-form-title {
  font-size: 20px;
  font-weight: bold;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  
  i {
    color: #3b82f6;
  }
}

.resume-form-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.resume-sync-checkbox {
  margin-right: 8px;
  font-size: 12px;
  color: #64748b;
}

.resume-form-badge {
  font-size: 12px;
  color: #64748b;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
}

.resume-edit-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.resume-edit-btn,
.resume-save-btn {
  background: transparent;
    border-color: transparent;
    box-shadow: none;
    background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%), linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding: 4px 8px;
  font-size: 14px;
    border-radius: 4px;
}

.resume-cancel-btn {
  padding: 4px 8px;
  font-size: 14px;
  border:0;
  background: transparent;
}

.resume-form-content {
  padding: 32px;
}

.resume-section {
  margin-bottom: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  // Element UI form 样式覆盖
  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }
  
  ::v-deep .el-form-item__label {
    font-size: 12px;
    color: #64748b;
    font-weight: 500;
    padding-bottom: 4px;
  }
}

.resume-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.resume-section-title {
  font-size: 12px;
  font-weight: bold;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  
  i {
    font-size: 14px;
  }
}

.resume-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.resume-item {
  position: relative;
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
  margin-bottom: 16px;
  
  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
}

.resume-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.resume-item-index {
  font-size: 14px;
  font-weight: 500;
    color: #64748b;
}
    
    .resume-item-delete {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px;
  font-size: 13px;
  
  &:hover {
    color: #ef4444;
    background: #fee2e2;
  }
  
  i {
    font-size: 14px;
  }
  
  span {
    font-size: 13px;
  }
}

.add-item-btn {
  width: 100%;
  padding: 8px;
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    border-color: #3b82f6;
    color: #3b82f6;
    background: rgba(59, 130, 246, 0.05);
  }
  
  i {
    font-size: 16px;
  }
}

/* 1280px 宽度下的兼容性优化 */
@media (max-width: 1280px) {
  .resume-form-content {
    padding: 24px 20px;
  }
  
  .resume-form-header {
    padding: 20px 24px;
    
    .no-card & {
      padding: 0 16px;
    }
  }
  
  .resume-section {
    margin-bottom: 32px;
  }
  
  /* 确保基本信息字段在 1280px 下每行显示2个，而不是3个 */
  /* 覆盖 Element UI 的 md 断点，在 1280px 下强制每行2个字段 */
  ::v-deep .resume-section:first-child {
    .el-row {
      margin-left: -12px !important;
      margin-right: -12px !important;
      
      .el-col {
        /* 在 1280px 下，强制每行显示2个字段（50%宽度，减去 gutter） */
        width: calc(50% - 24px) !important;
        flex: 0 0 calc(50% - 24px) !important;
        max-width: calc(50% - 24px) !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
      }
    }
  }
  
  /* 确保日期选择器在 1280px 下可以正常显示和编辑 */
  ::v-deep .el-date-editor {
    width: 100% !important;
    
    .el-input__inner {
      width: 100% !important;
      min-width: 0 !important;
    }
  }
  
  /* 确保日期选择器的下拉面板可以正常显示 */
  ::v-deep .el-picker-panel {
    z-index: 3000 !important;
  }
  
  /* 确保表单字段有足够的空间 */
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
  
  /* 确保工作经历等列表项不会挤压基本信息 */
  .resume-item {
    padding: 16px;
    margin-bottom: 12px;
  }
  
  /* 确保基本信息区域可见，不会被其他内容遮挡 */
  .resume-section:first-child {
    position: relative;
    z-index: 1;
  }
}
</style>

